// import Vue from 'vue';
// import GoogleMaps from "@/components/google-maps.vue";
// const Components = {
//     GoogleMaps,
// };
// Object.keys(Components).forEach(name => {
//     Vue.component(name, Components[name]);
// });
// export default Components

import GoogleMaps from "@/components/google-maps.vue";
export default GoogleMaps;